import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Text,
  List,
  ListItem,
  Flex,
  Input,
} from '@chakra-ui/react';

const TagOrManualEntryModal = ({ isOpen, onClose, tags, onSelect }) => {
  const [manualValue, setManualValue] = useState('');

  useEffect(() => {
    if (isOpen) {
      setManualValue('');
      console.log('Tags Data:', tags);
    }
  }, [isOpen]);

  const handleManualSubmit = () => {
    if (!isNaN(parseFloat(manualValue))) {
      onSelect({ name: manualValue, isManual: true });
      onClose();
    } else {
      alert('Please enter a valid float value.');
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select a Tag or Enter a Manual Value</ModalHeader>
        <ModalBody>
          <Text fontSize="lg" mb={2}>
            Tags:
          </Text>
          {tags.length === 0 ? (
            <Text>No devices or tags available</Text>
          ) : (
            <Accordion allowToggle>
              {tags.map(device => (
                <AccordionItem key={device.deviceId}>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      {device.deviceName}
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel>
                    {device.tags.length > 0 ? (
                      <List spacing={2}>
                        {device.tags.map(tag => (
                          <ListItem
                            key={tag.registerId}
                            cursor="pointer"
                            p={2}
                            _hover={{ bg: 'gray.100' }}
                            borderRadius="md"
                            onClick={() => {
                              onSelect(tag);
                              onClose();
                            }}
                          >
                            {tag.name}
                          </ListItem>
                        ))}
                      </List>
                    ) : (
                      <Text>No tags available for this device</Text>
                    )}
                  </AccordionPanel>
                </AccordionItem>
              ))}
            </Accordion>
          )}
          <Box mt={6}>
            <Text fontSize="lg" mb={2}>
              Manual Entry:
            </Text>
            <Flex gap={2}>
              <Input
                placeholder="Enter a float value"
                value={manualValue}
                onChange={e => setManualValue(e.target.value)}
              />
              <Button colorScheme="blue" onClick={handleManualSubmit}>
                Submit
              </Button>
            </Flex>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TagOrManualEntryModal;
